import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]
  static values = { options: Array }

  static PLACEHOLDER_ICON = `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="text-muted" viewBox="0 0 16 16">
      <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
      <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"/>
    </svg>
  `

  connect() {
    this.initTomSelect()
  }

  disconnect() {
    this.tomSelect?.destroy()
  }

  initTomSelect() {
    this.tomSelect = new TomSelect(this.selectTarget, {
      options: this.optionsValue,
      valueField: 'value',
      labelField: 'text',
      searchField: 'text',
      render: {
        option: (data, escape) => this.renderOption(data, escape),
        item: (data, escape) => this.renderItem(data, escape)
      }
    })
  }

  renderOption(data, escape) {
    const disabledClass = data.disabled ? 'opacity-50' : ''
    const statusText = data.disabled ? ' <span class="text-muted small">(nicht verfügbar)</span>' : ''
    const imageHtml = this.renderThumbnail(data.thumbnail, escape, 32)

    return `
      <div class="d-flex align-items-center py-1 ${disabledClass}">
        ${imageHtml}
        <span>${escape(data.text)}${statusText}</span>
      </div>
    `
  }

  renderItem(data, escape) {
    if (!data.thumbnail) {
      return `<div>${escape(data.text)}</div>`
    }

    return `
      <div class="d-flex align-items-center">
        ${this.renderThumbnail(data.thumbnail, escape, 24)}
        <span>${escape(data.text)}</span>
      </div>
    `
  }

  renderThumbnail(url, escape, size) {
    if (url) {
      return `<img src="${escape(url)}" class="rounded me-2" style="width: ${size}px; height: ${size}px; object-fit: cover;">`
    }

    return `
      <div class="bg-light rounded me-2 d-flex align-items-center justify-content-center" style="width: ${size}px; height: ${size}px;">
        ${this.constructor.PLACEHOLDER_ICON}
      </div>
    `
  }
}

